// import firebase from "firebase/app";
import firebase from "firebase";
// import "firebase/auth";
// import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCq6EjwCDrdn1J4xKDPfkYKbn6fCNM4KtM",
  authDomain: "manikpaulstore1980.firebaseapp.com",
  databaseURL: "https://manikpaulstore1980.firebaseio.com",
  projectId: "manikpaulstore1980",
  storageBucket: "manikpaulstore1980.appspot.com",
  messagingSenderId: "409080096304",
  appId: "1:409080096304:web:93683f4b269dc2970aeff5",
  measurementId: "G-F2MDRPEHG7",
};

// firebase.analytics();
const fire = firebase.initializeApp(firebaseConfig);
export default fire;
// export const auth = firebase.auth();
// export const firestore = firebase.firestore();
